// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__378hy","rotate":"styles_rotate__XxNCt"};